import { render, staticRenderFns } from "./BasketItem.vue?vue&type=template&id=29ebc76a&"
import script from "./BasketItem.vue?vue&type=script&lang=js&"
export * from "./BasketItem.vue?vue&type=script&lang=js&"
import style0 from "./BasketItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports